import React, { useEffect, useState, useMemo, useRef } from "react";
import { useForm } from "react-hook-form";
import MaterialTable from "material-table";
import Select from "react-select";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";

// leaflet
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";

// style
import "assets/css/map.css";
import {
  table_translate,
  table_style,
} from "../../../constants/MaterialTable.js";

// helpers
import { onlyNumber } from "../../../helpers/valid.js";
import {
  parseCoordenadas,
  MAPA_CENTRO_PADRAO,
  MAPA_ZOOM_PADRAO,
  MAPA_ZOOM_ENDERECO,
} from "../../../helpers/geo.js";

// services
import { InputCEP } from "../../../services/mask.js";
import { showMessage, showQuestion } from "../../../services/message.js";
import {
  api_GET,
  api_POST
} from "../../../services/api_service.js";
import {
  EnviaProtocoloDestinoLocal,
  EnviaRequerimentoDestinoLocal,
} from "../../../services/protocolo_destino_service.js";
import { GetCEPViaCEP } from "../../../services/viaCep";

//Context
import { useAuth } from "../../../context/auth";

export default function Locais({
  item,
  tipoCadastro,
  permiteManutencao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { session, setLoading } = useAuth();

  const {
    register,
    handleSubmit,
    errors,
    setError,
    setValue,
    clearErrors,
    reset,
    getValues,
  } = useForm({ mode: "onBlur" });

  const [permiteEditar, set_permiteEditar] = React.useState(true);

  const [registro, set_registro] = React.useState(null);

  const [locais_Destinacao, set_locais_Destinacao] = React.useState([]);

  const [modalOpen, set_modalOpen] = React.useState(false);
  const [localizacaoConfirmada, set_localizacaoConfirmada] = useState(false);

  useEffect(() => {
    if (tipoCadastro == "Protocolo") loadItemProtocolo();
    else if (tipoCadastro == "Requerimento") loadItemRequerimento();
  }, []);

  const loadItemProtocolo = () => {
    set_registro(item);
    if (
      item != null &&
      item.protocoloDestino[0].protocoloDestinoLocais != null
    ) {
      set_locais_Destinacao(item.protocoloDestino[0].protocoloDestinoLocais);
    }
  };
  const loadItemRequerimento = () => {
    set_registro(item);
    if (item != null && item.requerimentoDestinoLocais != null) {
      set_locais_Destinacao(item.requerimentoDestinoLocais);
    }

    if (tipoCadastro == "Requerimento") {
      let _action = actions;
      _action.push({
        icon: "delete",
        tooltip: "Remover Local",
        onClick: (event, rowData) => handleRemove(rowData),
      });

      set_actions(_action);
    }
  };

  // Material-Table > Actions
  const [actions, set_actions] = useState([
    {
      icon: "edit",
      tooltip: "Editar Registro",
      onClick: (event, rowData) => handleEdit(rowData),
    },
  ]);

  // Status
  const [status, set_status] = React.useState("");
  const [options_status] = React.useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Inativo", label: "Inativo" },
  ]);
  const handleStatus = (value) => {
    set_status(value);
    setValue("status", value, true);
    clearErrors("status");
  };

  // Capacidade
  const handleCapacidade = (event) => {
    setValue("capacidade", onlyNumber(event.target.value));
  };

  // CEP
  const [cep, set_cep] = React.useState("");
  const [editarEndereco, set_editarEndereco] = useState(true);
  const handleCEP = (event) => {
    set_cep(event.target.value);

    if (event.target.value.replaceAll("_", "").length != 9) {
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
        return;
    }

    clearErrors("cep");

    GetCEPViaCEP(event.target.value).then((result) => {
      if (
        result.status !== 200 ||
        (result.data.hasOwnProperty("erro") && result.data.erro == true)
      ) {
        showMessage("Aviso", "Cep não localizado", "warning", null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
        set_editarEndereco(true);
      } else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);

        if (
          result.data.logradouro == null ||
          result.data.logradouro.length == 0
        )
          set_editarEndereco(false);
        else {
          set_editarEndereco(true);

          let chave =
            result.data.logradouro.replaceAll(" ", "+") +
            "," +
            result.data.bairro.replaceAll(" ", "+") +
            "," +
            result.data.localidade.replaceAll(" ", "+");
          UpdatePositionEndereco(chave);
        }
      }
    });
  };
  const handleNumeroChange = (value) => {
    let data = getValues();
    let chave =
      data.logradouro.replaceAll(" ", "+") +
      "," +
      value +
      "," +
      data.bairro.replaceAll(" ", "+") +
      "," +
      data.cidade.replaceAll(" ", "+");
    UpdatePositionEndereco(chave);
  };

  const UpdatePositionEndereco = (chave) => {
    setLoading(true);
    api_POST(`GeoCoding/GetPositionEndereco`, chave)
    .then((result) => {
      setLoading(false);
      const coordenadas =
        result.status === 200
          ? parseCoordenadas(result?.data?.latitude, result?.data?.longitude)
          : null;
      if (coordenadas == null) {
        setCenterMap(MAPA_CENTRO_PADRAO);
        setpositionMarker(MAPA_CENTRO_PADRAO);
        set_zoomMap(MAPA_ZOOM_PADRAO);
        showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", "error", null);
      } else {
        setCenterMap(coordenadas);
        setpositionMarker(coordenadas);
        set_zoomMap(MAPA_ZOOM_ENDERECO);
      }
    })
    .catch((err) => showMessage("Aviso", err.message, "error", null))
    .finally(() => setLoading(false));
  };

  // Mapa
  const [centerMap, setCenterMap] = useState([0, 0]);
  const [positionMarker, setpositionMarker] = useState([0, 0]);
  const [zoomMap, set_zoomMap] = useState(MAPA_ZOOM_ENDERECO);
  const iconMarker = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
    iconRetinaUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
  });
  const markerRef = useRef(null);
  const handleMarkerPosition = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          let position = marker.getLatLng();
          setpositionMarker([position.lat, position.lng]);
        }
      },
    }),
    []
  );
  const ChangeMap = ({ center, zoom }) => {
    const mapInstance = useMap();
    mapInstance.setView(center, zoom);
    return null;
  };
  const handleModalClose = () => {
    set_modalOpen(false);
    set_localizacaoConfirmada(true);
  };

  const [rowEdit, set_rowEdit] = React.useState(null);
  const handleEdit = (rowData) => {
    set_localizacaoConfirmada(false);
    set_rowEdit(rowData);
    set_cep(rowData.cep);
    setValue("identificacao", rowData.identificacao);
    setValue("cep", rowData.cep);
    setValue("logradouro", rowData.logradouro);
    setValue("numEndereco", rowData.numEndereco);
    setValue("complemento", rowData.complemento);
    setValue("bairro", rowData.bairro);
    setValue("cidade", rowData.cidade);
    setValue("uf", rowData.uf);
    setValue("capacidade", rowData.capacidade);
    setValue("status", rowData.status, true);
    set_status(rowData.status);
    setValue("observacao", rowData.observacao);

    const coordenadas = rowData.geoLocalizacao
      ? parseCoordenadas(...rowData.geoLocalizacao.split(";"))
      : null;
    if (coordenadas != null) {
      setCenterMap(coordenadas);
      setpositionMarker(coordenadas);
      set_zoomMap(MAPA_ZOOM_ENDERECO);
    } else {
      setCenterMap(MAPA_CENTRO_PADRAO);
      setpositionMarker(MAPA_CENTRO_PADRAO);
      set_zoomMap(MAPA_ZOOM_PADRAO);
    }
  };

  const handleRemove = (rowData) => {
    if (!permiteManutencao && tipoCadastro == "Protocolo") {
      showMessage(
        "Aviso",
        "Não permitida a manutenção do cadastro.",
        "error",
        null
      );
      return;
    }

    showQuestion(
      "Atenção",
      "Deseja remover este local?",
      "question",
      function (result) {
        if (result) {
          setLoading(true);
          api_POST(
            "requerimentoDestino/PostRemoverDestinoLocalRequerimento/" +
              rowData.requerimentoDestinoLocal_Id
          )
            .then((result) => {
              showMessage(
                "Aviso",
                "Local removido com sucesso!",
                "success",
                function () {
                  handleReturnRemove(rowData.requerimento_Id);
                }
              );
            })
            .catch((err) => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
        }
      }
    );
  };
  const handleReturnRemove = (reloadId) => {
    setLoading(true);
    api_GET("requerimentoDestino/GetLocaisRequerimentoDestino/" + reloadId)
      .then((result) => set_locais_Destinacao(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const onSubmit = (data) => {
    if (
      item?.setupSolicitacaoAcao?.setupSolicitacao?.categoria?.classificacao ==
        "Banco Manejo" &&
      data.capacidade > 1000
    ) {
      showMessage(
        "Aviso",
        "O limite máximo de capacidade de recepção é de 1000m³. Por favor, altere o valor",
        "error",
        null
      );
      return;
    }

    if (
      rowEdit == null &&
      locais_Destinacao.filter(
        (f) => f.cEP == data.cep && f.numEndereco == data.numEndereco
      ).length > 0
    ) {
      showMessage(
        "Aviso",
        "Já existe um local de destinação neste endereço!",
        "error",
        null
      );
      return;
    }

    if (!localizacaoConfirmada) {
      set_modalOpen(true);
      return;
    }

    setLoading(true);
    if (permiteManutencao && tipoCadastro == "Protocolo") {
      let json = carregaJsonProtocolo(data);
      EnviaProtocoloDestinoLocal(json, confirmaAddLocais);
    } else if (tipoCadastro == "Requerimento") {
      let json = carregaJsonRequerimento(data);
      EnviaRequerimentoDestinoLocal(json, confirmaAddLocais);
    }
  };
  const carregaJsonProtocolo = (data) => {
    let json_submit = {
      protocoloDestinoLocal_Id:
        rowEdit == null ? 0 : rowEdit.protocoloDestinoLocal_Id,
      protocoloDestino_Id: item.protocoloDestino[0].protocoloDestino_Id,
      identificacao: data.identificacao,
      cEP: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numEndereco: data.numEndereco,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      geoLocalizacao: positionMarker[0] + ";" + positionMarker[1],
      usuarioUltimaAlteracao_Id:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? session.usuario_Id
          : null,
      capacidade: data.capacidade,
      status: status,
      observacao: data.observacao,
    };
    return json_submit;
  };
  const carregaJsonRequerimento = (data) => {
    let json_submit = {
      requerimentoDestinoLocal_Id:
        rowEdit == null ? 0 : rowEdit.requerimentoDestinoLocal_Id,
      requerimento_Id: item.requerimento_Id,
      identificacao: data.identificacao,
      cEP: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numEndereco: data.numEndereco,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      geoLocalizacao: positionMarker[0] + ";" + positionMarker[1],
      usuarioUltimaAlteracao_Id:
        session != null && session.tipoAcesso == "AreaRestrita"
          ? session.usuario_Id
          : null,
      capacidade: data.capacidade,
    };
    return json_submit;
  };
  const confirmaAddLocais = (result) => {
    setLoading(false);
    set_localizacaoConfirmada(false);

    let local = result.data;

    let new_list = [];

    let _registro = registro;
    if (tipoCadastro == "Protocolo") {
      locais_Destinacao.map((m) => {
        if (m.protocoloDestinoLocal_Id != local.protocoloDestinoLocal_Id)
          new_list.push(m);
      });

      _registro.protocoloDestino[0].protocoloDestinoLocais = new_list;
    } else if (tipoCadastro == "Requerimento") {
      locais_Destinacao.map((m) => {
        if (m.requerimentoDestinoLocal_Id != local.requerimentoDestinoLocal_Id)
          new_list.push(m);
      });

      _registro.requerimentoDestinoLocais = new_list;
    }

    new_list.push(local);
    set_locais_Destinacao(new_list);
    set_registro(_registro);

    set_cep("");
    setValue("cep", "");
    setValue("logradouro", "");
    setValue("numEndereco", "");
    setValue("complemento", "");
    setValue("bairro", "");
    setValue("cidade", "");
    setValue("uf", "");
    setValue("capacidade", "");
    setValue("identificacao", "");

    set_rowEdit(null);

    showMessage("Aviso", "Operação executada com sucesso", "success", null);
  };

  const handleAvancar = () => {
    if (
      (session == null || (session && session.tipoAcesso == "Protocolo")) &&
      locais_Destinacao.length == 0
    ) {
      showMessage(
        "Aviso",
        "Você não pode avançar sem informar os locais de destinação",
        "error",
        null
      );
      return;
    }
    handleProximoStep(registro);
  };

  return (
    <>
      <div>
        <Card className={`card card-stats`}>
          <CardBody>
            <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
              <h2 className="titulo-solicitacao">Locais de Destinação</h2>
              <div className="formPrincipal">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row className="align-items-end">
                    {tipoCadastro == "Protocolo" && (
                      <Col md="3">
                        <FormGroup>
                          <b>
                            <label>Status</label>
                          </b>
                          <Select
                            options={options_status}
                            name="status"
                            onChange={(e) => {
                              handleStatus(e.value);
                            }}
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ value }) => value}
                            value={
                              status != "" &&
                              options_status.find((obj) => obj.value === status)
                            }
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "status" },
                                { required: permiteEditar }
                              )
                            }
                          />
                          {errors.status && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    )}
                    <Col md="9" lg="9">
                      <FormGroup>
                        <b>
                          <label>Identificação</label>
                        </b>
                        <Input
                          type="text"
                          name="identificacao"
                          maxLength="100"
                          innerRef={register({ required: true })}
                        />
                        {errors.identificacao && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="3" lg="3">
                      <FormGroup>
                        <b>
                          <label>CEP</label>
                        </b>
                        <InputCEP
                          name="cep"
                          onChange={handleCEP}
                          value={cep}
                          inputRef={register({ required: true })}
                        />
                        {errors.cep && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="5" lg="5">
                      <FormGroup>
                        <b>
                          <label>Logradouro</label>
                        </b>
                        <Input
                          type="text"
                          name="logradouro"
                          readOnly={editarEndereco}
                          maxLength="100"
                          innerRef={register({ required: true })}
                        />
                        {errors.logradouro && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4" lg="4">
                      <FormGroup>
                        <b>
                          <label>Bairro</label>
                        </b>
                        <Input
                          type="text"
                          name="bairro"
                          readOnly={editarEndereco}
                          maxLength="50"
                          innerRef={register({ required: true })}
                        />
                        {errors.bairro && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="2" lg="2">
                      <FormGroup>
                        <b>
                          <label>Número</label>
                        </b>
                        <Input
                          type="number"
                          name="numEndereco"
                          maxLength="10"
                          innerRef={register({ required: true })}
                          onBlur={(e) => handleNumeroChange(e.target.value)}
                        />
                        {errors.numEndereco && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="3" lg="3">
                      <FormGroup>
                        <b>
                          <label>Complemento</label>
                        </b>
                        <Input
                          type="text"
                          name="complemento"
                          maxLength="50"
                          innerRef={register({ required: false })}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3" lg="3">
                      <FormGroup>
                        <b>
                          <label>Cidade</label>
                        </b>
                        <Input
                          type="text"
                          name="cidade"
                          readonly="readonly"
                          maxLength="50"
                          innerRef={register({ required: true })}
                        />
                        {errors.cidade && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="1" lg="1">
                      <FormGroup>
                        <b>
                          <label>UF</label>
                        </b>
                        <Input
                          type="text"
                          name="uf"
                          readonly="readonly"
                          innerRef={register({ required: true })}
                        />
                        {errors.uf && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <b>
                          <label>
                            <span className="text-danger">*</span> Capacidade de
                            Recepção (m³){" "}
                            <a href="#" id="questionCapacidade">
                              <i className="fas fa-question-circle"></i>
                            </a>
                            <UncontrolledTooltip
                              target="questionCapacidade"
                              placement="top"
                            >
                              Apenas números inteiros devem ser informados.
                            </UncontrolledTooltip>
                          </label>
                        </b>
                        <Input
                          type="number"
                          name="capacidade"
                          innerRef={register({
                            required: permiteEditar,
                          })}
                          onChange={handleCapacidade}
                        />
                        {errors.capacidade && (
                          <span className="form-control-label text-danger">
                            * Campo Obrigatório
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                    {tipoCadastro == "Protocolo" && (
                      <Col md="12" lg="12">
                        <FormGroup>
                          <b>
                            <label>Observação</label>
                          </b>
                          <Input
                            type="text"
                            name="observacao"
                            maxLength="500"
                            innerRef={register({ required: true })}
                          />
                          {errors.observacao && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    )}
                    <Col md="1" lg="1">
                      <Button
                        color="info"
                        className="btn-mobile"
                        type="button"
                        onClick={() => set_modalOpen(true)}
                      >
                        <i className="fas fa-map-marked-alt"></i>
                      </Button>
                    </Col>
                    {permiteEditar && (
                      <Col lg="12" className="text-center">
                        <FormGroup>
                          <Button
                            color="success"
                            className="btn-mobile"
                            type="submit"
                          >
                            {" "}
                            <i className="fas fa-save"></i> Salvar Local
                          </Button>
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                </Form>
              </div>
              <Row>
                <Col md="12">
                  <MaterialTable
                    style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: "Identificação", field: "identificacao" },
                      { title: "Capacidade", field: "capacidade" },
                      { title: "CEP", field: "cep" },
                      { title: "Logradouro", field: "logradouro" },
                      { title: "Número", field: "numEndereco" },
                      { title: "Complemento", field: "complemento" },
                      { title: "Bairro", field: "bairro" },
                      { title: "Cidade", field: "cidade" },
                      { title: "UF", field: "uf" },
                      {
                        title: "Status",
                        render: (rowData) =>
                          rowData.status != null ? rowData.status : "Ativo",
                      },
                    ]}
                    data={locais_Destinacao}
                    isLoading={false}
                    actions={actions}
                    localization={table_translate}
                    options={table_style}
                  />
                </Col>
                <Col lg="6" className="text-left">
                  <Button
                    color="secundary"
                    onClick={() => handleStepAnterior(registro)}
                    className="btn-mobile"
                    type="submit"
                  >
                    <i className="fas fa-chevron-left"></i> Voltar
                  </Button>
                </Col>
                <Col lg="6" className="text-right">
                  <Button
                    color="success"
                    onClick={handleAvancar}
                    className="btn-mobile"
                    type="button"
                  >
                    Próxima Etapa <i className="fas fa-chevron-right"></i>
                  </Button>
                </Col>
              </Row>
            </Container>
          </CardBody>
        </Card>
      </div>
      <Modal
        centered
        isOpen={modalOpen}
        toggle={handleModalClose}
        zIndex="9999999"
      >
        <ModalBody className="md-bd">
          <h6>Confirme o Local no Mapa</h6>
          <Row className="mt-2">
            <Col lg="12">
              <div id="map">
                <MapContainer style={{ zIndex: "0" }}>
                  <ChangeMap center={centerMap} zoom={zoomMap}></ChangeMap>
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    opacity={0.5}
                  />
                  <Marker
                    position={positionMarker}
                    draggable={true}
                    icon={iconMarker}
                    ref={markerRef}
                    eventHandlers={handleMarkerPosition}
                  ></Marker>
                </MapContainer>
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="md-ft">
          <Button color="secondary" outline onClick={handleModalClose}>
            Confirmar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
